import { SET_ADMIN_NOTIFICATIONS, CLEAR_ADMIN_NOTIFICATIONS } from "../actions/notificationAdminActions";

const initialState = {
  adminNotifications: []
}

function adminNotificationReducer(state = initialState, action) {
  switch (action.type) {
  case SET_ADMIN_NOTIFICATIONS:
    return {
      ...state,
      adminNotifications: action.payload
    }
  case CLEAR_ADMIN_NOTIFICATIONS:
    return {
      ...state,
      adminNotifications: []
    }
  default:
    return state;
  }
}

export default adminNotificationReducer;